import { render } from "./App.vue?vue&type=template&id=568b9edc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=568b9edc&lang=scss"

import exportComponent from "/var/www/mysimplediary.leandrosabatini.com/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__